export function customCtrl(
    map,
    options,
    style,
    listener
) {
    this.defaultAnchor = options.anchor || BMAP_ANCHOR_TOP_LEFT
    console.log('BMAP_ANCHOR_TOP_LEFT', BMAP_ANCHOR_BOTTOM_LEFT)
    if (options.offset) {
        this.defaultOffset = new map.Size(options.offset[0], options.offset[1])
    } else {
        this.defaultOffset = new map.Size(20, 20)
    }
    this.buttonText = options.buttonText
    this.style = style
    this.listener = listener
}

export default {
    customCtrl
}